import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import { CONTACT_EMAIL } from '../constants';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: theme.spacing(70),
    margin: 'auto',
  },
  title: {
    marginBottom: theme.spacing(2),
  },
}));

export const ContactPage = (): JSX.Element => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography variant="h5" className={classes.title}>
        Contact
      </Typography>
      <Typography>FlashyPlayer is currently in BETA version.</Typography>
      <Typography>
        Please send your feedback and suggestions at{' '}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </Typography>
    </div>
  );
};
